export const trackerPermission = {
    scrapeTasksView: "scrape-tasks.view",
    scrapeTaskDelete: "scrape-task.delete",
    scrapeTaskStop: "scrape-task.stop",
    scrapeTaskHttpResponseView: "scrape-task-http-response.view",
    scrapeTaskMetadataView: "scrape-task-metadata.view",
    scrapeTaskResultObjectsView: "scrape-task-result-objects.view",
    scrapeTaskHttpRequestView: "scrape-task-http-request.view",
    trackerViewTreeButton: "tracker.view-tree-button",
    trackerExportResults: "tracker.export-results",
    statusHistoryView: "status-history.view",
    trackerFilterMustHaveMessage: "tracker.filter-must-have-message",
    trackerFilterTrackId: "tracker.filter-track-id",
    trackerFilterSource: "tracker.filter-source",
    trackerFilterParentId: "tracker.filter-parent-id",
    trackerFilterInitialTrackId: "tracker.filter-initial-track-id",
    trackerFilterTemplateCode: "tracker.filter-template-code",
    trackerFilterHasMessage: "tracker.filter-has-message",
    trackerFilterHasHttpResponse: "tracker.filter-has-http-response",
    trackerFilterHasRetryAttempt: "tracker.filter-has-retry-attempt",
    trackerFilterIsInitial: "tracker.filter-is-initial",
    trackerFilterIsSandboxMode: "tracker.filter-is-sandbox-mode",
    trackerFilterDebugMode: "tracker.filter-debug-mode",
    trackerFilterIsTemplateRecognized: "tracker.filter-is-template-recognized",
    trackerFilterStatusType: "tracker.filter-status-type",
    trackerFilterFilterStatus: "tracker.filter-status",
    trackerViewsAllTrack: "scrape-tasks.view-all",
    trackerResendScrapedResults: "scrape-task.resend-scraped-results"
};
